import Link from "next/link";
import React, { FunctionComponent, useState } from "react";

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";

interface LinkButtonProps {
  text: string;
  onClick?: () => void;
  url?: string;
  locale?: string;
  variant?: "code1" | "navigation1";
  brackets?: boolean;
  target?: React.HTMLAttributeAnchorTarget | undefined;
}

export const LinkButton: FunctionComponent<LinkButtonProps> = ({
  text,
  onClick,
  url,
  locale,
  variant = "navigation1",
  brackets = true,
  target,
}) => {
  const theme = useTheme();
  const [hover, setHover] = useState(false);

  return (
    <Link href={url ?? ""} passHref={!!url} locale={locale} target={target}>
      <Box
        component={!!url ? "div" : "div"}
        onClick={() => onClick && onClick()}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{
          ":hover": {
            cursor: "pointer",
          },
          "pt": "8px",
          "pb": "8px",
          "position": "relative",
          "textDecoration": "none",
        }}
      >
        <Typography
          variant={variant}
          sx={{
            [theme.breakpoints.between("tablet", "desktop")]: {
              fontSize: "18px",
            },
          }}
        >
          {text}
        </Typography>

        {hover && brackets && (
          <>
            <Typography
              variant={variant}
              sx={{
                position: "absolute",
                left: "-15px",
                top: "20%",
              }}
            >
              {"<"}
            </Typography>

            <Typography
              variant={variant}
              sx={{
                position: "absolute",
                right: "-15px",
                top: "20%",
              }}
            >
              {">"}
            </Typography>
          </>
        )}
      </Box>
    </Link>
  );
};
